import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../component";
import { useEffect, useMemo, useState } from "react";
import { columns } from "./columns";
import CustomTable from "rc-material-table";
import { getToast } from "../../common/utils";
import { useApi } from "../../hooks";
import keyNames from "../../keyName";
import { apiCasestudy, apiPrArticle, method } from "../../apiPath";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
const { get } = method;

const PrArticle = () => {
  const navigate = useNavigate();
  const hitApi = useApi();
  const storeData = useSelector((state) => state.mainReducer);
  const { prArticleData } = storeData;
  const [entries, setEntries] = useState([]);
  const callBack = (cbd) => {
    navigate("/app/add-pr-article", { state: cbd });
  };
  const btn = {
    show: true,
    text: "Add Pr Article",
    type: "contained",
    callBack: () => callBack("add"),
  };

  useEffect(() => {
    if (!prArticleData) {
      hitApi(apiPrArticle, null, get, keyNames.prArticleData);
    } else if (Array.isArray(prArticleData)) {
      setEntries(
        prArticleData.map((item, index) => ({
          ...item,
          sortOrder: index + 1,
        }))
      );
    }
  }, [prArticleData, hitApi]);

  const handleView = (item, path) => {
    navigate(path, { state: item });
  };

  const handleDelete = (id) => {
    const toast = getToast("success");
    hitApi(
      `${apiPrArticle}/${id}`,
      null,
      method.delete,
      keyNames.prArticleData,
      toast,
      {
        type: "delete",
      }
    );
  };
  // pagination

  // const [page, setPage] = useState(state?.page ?? 0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const pagination = {
    rowsPerPageOptions: [8, 10, 20],
    rowsPerPage: rowsPerPage,
    page: page,
    count: entries.length,
    component: "div",
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
  };
  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    return entries.slice(startIndex, startIndex + rowsPerPage);
  }, [entries, page, rowsPerPage]);

  return (
    <>
      <PageHeader btn={btn} title="All PR Articles" />

      {entries.length === 0 ? (
        <Box
          sx={{
            mt: 5,
            textAlign: "center",
            p: 4,
            border: "1px dashed grey",
            borderRadius: 2,
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No Pr Article found for this user.
          </Typography>
        </Box>
      ) : (
        <CustomTable
          columns={columns(handleView, handleDelete)}
          data={paginatedData ?? []}
          pagination={pagination}
          tableProps={{
            stickyHeader: true,
          }}
          sx={{
            mt: 3,
            "&>.MuiPaper-elevation": {
              boxShadow: "none",
              overflowX: "auto",
              maxHeight: "calc(100vh - 260px)",
            },
          }}
        />
      )}
    </>
  );
};

export default PrArticle;
